export default __webpack_public_path__ + "static/media/lift_up_2.b7676935.png";